import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import config from "./config"

function AdminmanualTransferHistory() {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const userData = async () => {
        try {
            let params = {
                url: `adminmanualhistory`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            if (response.status === true) {
                setData(response.data);
            } else {
                setData([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };

    useEffect(() => {
        userData();
    }, []);

    const compressString = (str) => {
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };
    const formatISTDate = (dateString) => {

        if (!dateString) return "-";


        const date = new Date(dateString);

        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const columns = [
        { name: 'S.No', width: '100px', selector: (row) => row.sno },
        {
            name: 'Date',
            width: '200px',
            selector: row => row.date ? formatISTDate(row.date) : "-",
            cell: (row) => <div className="no-wrap-cell">{row.date ? formatISTDate(row.date) : "-"}</div>,
        },
        {
            name: 'Email',
            width: "350px",
            selector: (row) => row.email,
            cell: (row) => <div className="no-wrap-cell">{row.email}</div>,
        },

        {
            name: 'Coin',
            width: '300px',
            selector: (row) => row.symbol,
            cell: (row) => <div className="no-wrap-cell">{row.symbol}</div>,
        },

        {
            name: 'Amount',
            width: '200px',
            selector: (row) => row.amount,
            cell: (row) => <div className="no-wrap-cell">{row.amount}</div>,
        },
    ];

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            if (typeof selector(a) === "string") {
                const aField = selector(a).toLowerCase();
                const bField = selector(b).toLowerCase();

                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            } else {
                const aField = selector(a).props.children ? parseFloat(selector(a).props.children) : 0;
                const bField = selector(b).props.children ? parseFloat(selector(b).props.children) : 0;
                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            }
        });
    };

    const formattedData = data && Array.isArray(data) ? data.map((row, index) => ({

        sno: index + 1,
        _id: row._id,
        email: row.email ? row.email : "-",
        date: row.date ? row.date : "-",
        symbol: row.symbol ? row.symbol : "-",
        amount: row.amount ? row.amount : "-"

    })) : [];

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
    };
    const filteredData = formattedData
        .filter(item => {
            const formattedDate = formatISTDate(item.date);
            const searchTermLower = searchTerm.toLowerCase();
            const isDateSearch = searchTermLower.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (isDateSearch) {
                const dateMatch = formattedDate.toLowerCase().includes(searchTermLower);
                return dateMatch ||
                    item.email.toLowerCase().includes(searchTermLower) ||
                    item.symbol.toUpperCase().includes(searchTerm.toUpperCase());
            }
            return (
                formattedDate.toLowerCase().includes(searchTermLower) ||
                item.email.toLowerCase().includes(searchTermLower) ||
                item.symbol.toUpperCase().includes(searchTerm.toUpperCase())
            );
        })
        .map((item, index) => ({
            ...item,
            sno: index + 1
        }));

    return (
        <div className='App'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="custom-saled-order text-dark ms-3">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">Admin Manual Transfer History</h3>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search by Email"
                                    // style={{ "margin": "25px" }}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className='form-search mb-4'
                                /> <br />
                                <div className='custom-datascroll'>
                                    <DataTable
                                        className="text-center "
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        persistTableHead
                                        sortFunction={customSort}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AdminmanualTransferHistory